<div class="section-container">
  <div class="tiers">
    <div *ngFor="let plan of plans" [ngClass]="'tier ' + plan.class">
      <header>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 8px;
            align-items: flex-start;
          "
        >
          <div class="price" [style.marginBottom]="plan.marginBottom || '0'">
            <span class="numerator">{{ plan.price }}</span>
            <span *ngIf="plan.denominator" class="denominator">{{ plan.denominator }}</span>
          </div>
          <span *ngIf="plan.showIvaIncluded" class="iva">IVA incluido</span>
        </div>
        <h3 class="title">{{ plan.title }}</h3>
        <span class="description">{{ plan.description }}</span>
      </header>
      <hr />
      <ul class="features">
        <li *ngFor="let feature of plan.features">
          <span class="icon">
            <i class="pi pi-check" style="color: var(--color-secondary); font-size: 16px"></i>
          </span>
          <span class="item">
            <ng-container *ngIf="feature === 'Integraciones Meta'; else normalFeature">
              {{ feature }}
              <span
                class="tooltip-container"
                (mouseenter)="showTooltip = true"
                (mouseleave)="showTooltip = false"
                (click)="toggleTooltip()"
              >
                <i class="pi pi-info-circle" style="font-size: 1.1rem; color: #3a3c5d"></i>
                <span class="tooltip" [class.show]="showTooltip">
                  Whatsapp, Facebook, Instagram
                </span>
              </span>
            </ng-container>
            <ng-template #normalFeature>
              {{ feature }}
            </ng-template>
          </span>
        </li>
      </ul>
      <ng-container *ngIf="isUpgrade(plan); else downgradeOrLink">
        <button type="button" class="button" [disabled]="isCurrentPlan(plan)" (click)="onPlanAction(plan)">Actualizar</button>
      </ng-container>
      <ng-template #downgradeOrLink>
        <ng-container *ngIf="isDowngrade(plan); else linkPlan">
          <button type="button" class="button" [disabled]="isCurrentPlan(plan)" (click)="onPlanAction(plan)">Bajar a este plan</button>
        </ng-container>
        <ng-template #linkPlan>
          <button
            *ngIf="isReactivateTarget(plan) && !isCurrentPlan(plan)"
            type="button"
            class="button"
            (click)="onPlanAction(plan)"
          >
            {{ plan.buttonText }}
          </button>
          <a
            *ngIf="!isReactivateTarget(plan) && !isCurrentPlan(plan)"
            [href]="plan.link"
            class="button"
            >{{ plan.buttonText }}</a
          >
          <button *ngIf="isCurrentPlan(plan)" type="button" class="button" disabled>{{ plan.buttonText }}</button>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <div class="pay-box">
    <span class="text-information font-normal"
      >La conversión de divisa se aplica al pagar según el país y método de pago.</span
    >
    <div class="logos">
      <div class="flex align-items-center gap-4">
        <img src="assets/img/webpay-modal.svg" alt="webpay" height="52" />
        <img src="assets/img/payment_logos.svg" alt="payment_logos" height="52" />
      </div>
      <div class="flex align-items-center justify-content-center" style="height: 52px; gap: 6px">
        <span
          class="font-semibold"
          style="font-size: 16px; line-height: 61.5px; letter-spacing: 0.2px"
          >Pago con Webpay</span
        >
        <img src="assets/img/webpay.svg" alt="Webpay" height="24" />
      </div>
    </div>
  </div>
</div>
